'use client';

import { createContext } from 'react';

import type { VerticalNavContextInterface } from '../types/vertical-nav-root.types';

export const VerticalNavContext = createContext<VerticalNavContextInterface>({});

VerticalNavContext.displayName = 'VerticalNav.Context';
